export const PAGE_TITLE_NEW_CAR_PRICE_LIST = 'New Car Pricelist';
export const PILL_ACTIVE_BACKGROUND_COLOR_RED_1 = 'red-1';
export const PILL_ACTIVE_TEXT_WEIGHT_SEMIBOLD = 'semibold';
export const PILL_BACKGROUND_COLOR_GRAY_1 = 'gray-1';
export const TEXT_MONTHS = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];
